var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "34", height: "34", viewBox: "0 0 34 34", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-34a)" },
      React.createElement("circle", { cx: "17", cy: "17", r: "17", fill: "#FFD700" }),
      React.createElement("path", { d: "M17 2.25C25.1462 2.25 31.75 8.8538 31.75 17C31.75 25.1462 25.1462 31.75 17 31.75C8.8538 31.75 2.25 25.1462 2.25 17C2.25 8.8538 8.8538 2.25 17 2.25ZM17 3.75C9.68223 3.75 3.75 9.68223 3.75 17C3.75 24.3178 9.68223 30.25 17 30.25C24.3178 30.25 30.25 24.3178 30.25 17C30.25 9.68223 24.3178 3.75 17 3.75ZM19.75 8.2998C22.3257 8.63539 24.3646 10.6743 24.7002 13.25H25.75V18.75H24.75V19C24.75 23.2802 21.2802 26.75 17 26.75C12.7198 26.75 9.25 23.2802 9.25 19V18.75H8.25V13.25H9.2998C9.63539 10.6743 11.6743 8.63539 14.25 8.2998V7.25H19.75V8.2998ZM10.75 19C10.75 22.4518 13.5482 25.25 17 25.25C20.4518 25.25 23.25 22.4518 23.25 19V18.75H10.75V19ZM9.75 17.25H24.25V14.75H9.75V17.25ZM14.25 9.81641C12.5041 10.1273 11.1283 11.5041 10.8174 13.25H14.25V9.81641ZM15.75 13.25H18.25V8.75H15.75V13.25ZM19.75 13.25H23.1826C22.8717 11.5041 21.4959 10.1273 19.75 9.81641V13.25Z", fill: "#303030" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-34a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H34V34H0z" })
      )
    )
  );
});